import { render, staticRenderFns } from "./disputedReadFormElectricity.vue?vue&type=template&id=21cb8766"
import script from "./disputedReadFormElectricity.vue?vue&type=script&lang=js"
export * from "./disputedReadFormElectricity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports